import { type ReactNode } from 'react'
import cn from 'classnames'

interface FormFieldProps {
  label?: string
  preLabel?: string
  placeholder?: string
  additionalClasses?: string
  value: string
  children?: ReactNode
}

export const DisabledInput: React.FC<FormFieldProps> = ({
  label,
  preLabel,
  placeholder,
  additionalClasses,
  value,
  children
}) => {
  return (
    <div className="flex flex-col w-full mx-2">
      <label>{label}</label>
      <div className="relative">
        {preLabel && (
          <div className="absolute left-4 top-1 text-lg">{preLabel}</div>
        )}
        <input
          disabled
          className={cn(additionalClasses, 'py-2 text-left w-full h-full border rounded-md', preLabel ? 'pl-8' : 'pl-4')}
          placeholder={placeholder}
          value={value}
        />

      </div>

      {children}
    </div>
  )
}
